import { useState, useEffect, useRef } from 'react';
import { II } from '../../components/common/Icons';
import api from '../../services/api';
import HrModal from './HrModal';
import T from '../../assets/styles/theme';
import "../../assets/styles/HR/HrPoliciesPg.css";

function HrPoliciesPg() {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editPolicy, setEditPolicy] = useState(null);
  const [suc, setSuc] = useState('');
  const fileRef = useRef(null);

  const fetchPolicies = async () => {
    try {
      const d = await api.getHrPolicies();
      setPolicies(Array.isArray(d) ? d : []);
    } catch (_) {
      setPolicies([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPolicies();
  }, []);


  const handleSave = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    try {
      if (editPolicy) {
        const updateFd = new FormData();
        updateFd.append('title', fd.get('title') || '');
        updateFd.append('name', fd.get('name') || fd.get('title') || '');
        updateFd.append('category', fd.get('category') || 'General');
        updateFd.set('audience', fd.get('audience') || 'all');
        updateFd.append('summary', fd.get('summary') || '');
        updateFd.append('status', fd.get('status') || 'Active');
        const file = fd.get('file');
        if (file && file.name) updateFd.append('file', file);
        await api.updatePolicyHR(editPolicy.id, updateFd);
        setSuc('Policy updated!');
      } else {
        if (!fd.get('title')) throw new Error('Title is required');
        const file = fd.get('file');
        if (!file || !file.name) throw new Error('Document file is required');
        fd.append('name', fd.get('name') || fd.get('title'));
        fd.set('audience', fd.get('audience') || 'all');
        await api.createPolicyWithFile(fd);
        setSuc('Policy created!');
      }
      await fetchPolicies();
    } catch (err) {
      alert('Error: ' + err.message);
    }
    setShowForm(false);
    setEditPolicy(null);
    setTimeout(() => setSuc(''), 4000);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this policy?')) return;
    try {
      await api.deletePolicyHR(id);
      await fetchPolicies();
      setSuc('Policy deleted');
      setTimeout(() => setSuc(''), 4000);
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  const handleDownload = async (policy) => {
    try {
      const res = await api.downloadPolicy(policy.id);
      const filename = res?.name || policy.name || policy.title || 'policy';
      if (res?.url) {
        await api.downloadFile(res.url, filename);
        return;
      }
      if (res?.content) {
        const blob = new Blob([res.content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename.endsWith('.txt') ? filename : `${filename}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      alert('Download failed: ' + err.message);
    }
  };

  return (
    <div>
      <div className="sec">Policy Management</div>
      {suc && <div className="hrpoliciespg-inline-1">OK {suc}</div>}
      <div className="hrpoliciespg-inline-2">
        <div style={{ "--hrpoliciespg-1-color": T.textMuted }} className="hrpoliciespg-dyn-1">
          {policies.length} policies | Audience controlled by HR
        </div>
        <button className="btn btn-p" onClick={() => { setEditPolicy(null); setShowForm(true); }}>
          {II('plus', 14)} Add Policy
        </button>
      </div>

      <div className="cd">
        <div className="cd-b hrpoliciespg-inline-3">
          {loading ? <div style={{ "--hrpoliciespg-2-color": T.textMuted }} className="hrpoliciespg-dyn-2">Loading...</div> :
            <table className="tbl">
              <thead><tr><th>Title</th><th>Category</th><th>Visible To</th><th>Summary</th><th>File</th><th>Status</th><th>Updated</th><th>Actions</th></tr></thead>
              <tbody>{policies.length === 0 ? <tr><td colSpan="8" style={{ "--hrpoliciespg-3-color": T.textMuted }} className="hrpoliciespg-dyn-3">No policies yet</td></tr> :
                policies.map((p) =>
                  <tr key={p.id}>
                    <td className="hrpoliciespg-inline-4">{p.name || p.title}</td>
                    <td><span className="chip chip-ip">{p.category || 'General'}</span></td>
                    <td><span className="chip chip-p">{String(p.audience || 'all') === 'employee' ? 'Employees' : String(p.audience || 'all') === 'intern' ? 'Interns' : 'All'}</span></td>
                    <td className="hrpoliciespg-inline-5">{p.summary || '-'}</td>
                    <td>{p.file_path ? <span className="hrpoliciespg-inline-6">Attached</span> : <span className="hrpoliciespg-inline-7">No file</span>}</td>
                    <td><span className={'chip ' + (String(p.status || '').toLowerCase() === 'active' ? 'chip-ok' : 'chip-dn')}>{String(p.status || '').toLowerCase() === 'inactive' ? 'Inactive' : 'Active'}</span></td>
                    <td style={{ "--hrpoliciespg-4-color": T.textMuted }} className="hrpoliciespg-dyn-4">{p.updated ? new Date(p.updated).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                    <td><div className="hrpoliciespg-inline-8">
                      <button className="btn btn-s" onClick={() => handleDownload(p)} disabled={!p.file_path}>Download</button>
                      <button className="btn btn-s" onClick={() => { setEditPolicy(p); setShowForm(true); }}>Edit</button>
                      <button className="btn btn-s hrpoliciespg-inline-9" onClick={() => handleDelete(p.id)}>Del</button>
                    </div></td>
                  </tr>
                )}</tbody>
            </table>}
        </div>
      </div>

      {showForm && <HrModal open={showForm} title={editPolicy ? 'Edit Policy' : 'Add Policy'} onClose={() => { setShowForm(false); setEditPolicy(null); }}>
        <form onSubmit={handleSave}>
          <div className="fg"><label className="fl">Title *</label><input name="title" className="fi" defaultValue={editPolicy?.title || editPolicy?.name || ''} placeholder="Policy title..." required /></div>
          <div className="fg"><label className="fl">File Name *</label><input name="name" className="fi" defaultValue={editPolicy?.name || editPolicy?.title || ''} placeholder="Type display file name..." required /></div>
          <div className="fg"><label className="fl">Category</label>
            <select name="category" className="fi" defaultValue={editPolicy?.category || 'General'}>
              <option value="General">General</option><option value="HR">HR</option><option value="Leave">Leave</option>
              <option value="Compliance">Compliance</option><option value="IT">IT</option><option value="Finance">Finance</option><option value="Safety">Safety</option>
            </select></div>
          <div className="fg"><label className="fl">Visible To</label>
            <select name="audience" className="fi" defaultValue={editPolicy?.audience || 'all'}>
              <option value="all">All Employees & Interns</option>
              <option value="employee">Employees Only</option>
              <option value="intern">Interns Only</option>
            </select></div>
          <div className="fg"><label className="fl">Summary / Content</label><textarea name="summary" className="fi" rows={4} defaultValue={editPolicy?.summary || ''} placeholder="Policy details..." /></div>
          <div className="fg"><label className="fl">{editPolicy ? 'Re-upload Document (optional)' : 'Upload Document (PDF/DOC)'}</label>
            <input ref={fileRef} name="file" type="file" accept=".pdf,.doc,.docx,.txt" className="fi" required={!editPolicy} />
            <div style={{ "--hrpoliciespg-5-color": T.textMuted }} className="hrpoliciespg-dyn-5">Max 10MB. Supported: PDF, DOC, DOCX, TXT</div>
          </div>
          <div className="fg"><label className="fl">Status</label>
            <select name="status" className="fi" defaultValue={editPolicy?.status || 'Active'}>
              <option value="Active">Active</option><option value="Inactive">Inactive</option>
            </select></div>
          <div className="fa"><button type="button" className="btn btn-o" onClick={() => { setShowForm(false); setEditPolicy(null); }}>Cancel</button><button type="submit" className="btn btn-p">{editPolicy ? 'Update' : 'Upload'} Policy</button></div>
        </form>
      </HrModal>}
    </div>
  );
}

export default HrPoliciesPg;
